export enum ActionType {
  CAN_VIEW = "can_view",
  CAN_ADD = "can_add",
  CAN_UPDATE = "can_update",
  CAN_DELETE = "can_delete",
}